var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40485 11.8296C1.17389 8.00575 2.81155 3.99744 6.48314 2.81535C8.24043 2.25009 10.142 2.4535 11.733 3.35629L11.9964 3.51435L12.2645 3.35541C13.773 2.50136 15.5624 2.27315 17.2463 2.73629L17.512 2.81541C21.1847 3.99786 22.8291 8.00807 21.5937 11.8452C20.9743 13.6302 19.9584 15.2485 18.6174 16.5824C16.7927 18.3546 14.7812 19.9195 12.6219 21.2473L12.3926 21.3898C12.1598 21.5345 11.8656 21.5369 11.6305 21.3962L11.3849 21.2492C9.22257 19.9195 7.21104 18.3546 5.38007 16.5763C4.04537 15.2485 3.0295 13.6302 2.40485 11.8296ZM15.9541 5.48388C15.5694 5.36108 15.1578 5.57318 15.0349 5.95763C14.912 6.34209 15.1243 6.75331 15.509 6.87612C16.2653 7.1175 16.8045 7.79818 16.872 8.6011C16.9058 9.00327 17.2596 9.3019 17.6621 9.26809C18.0646 9.23428 18.3634 8.88085 18.3296 8.47867C18.2127 7.08873 17.2756 5.90566 15.9541 5.48388Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.b2470dab0c0ae07abe02a52f9d1a8771.svg";
export { ForwardRef as ReactComponent };